import { render, staticRenderFns } from "./information-edit.vue?vue&type=template&id=5c33a79d&scoped=true&"
import script from "./information-edit.vue?vue&type=script&lang=js&"
export * from "./information-edit.vue?vue&type=script&lang=js&"
import style0 from "./information-edit.vue?vue&type=style&index=0&id=5c33a79d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c33a79d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VChip,VCol,VContainer,VFileInput,VIcon,VRow,VSelect,VSubheader})
